(function () {
    'use strict';
    var m = angular.module('common');
    m.directive('formParam', ["path", "modals", "$timeout", "$rootScope", "regexUtility", "$parse", function (path, modals, $timeout, $rootScope, regexUtility, $parse) {
        return {
            restrict: 'A',
            replace: true,
            templateUrl: path('common').directive('form-param').template(),
            scope: {
                param: '=formParam',
                model: '=ngModel',
                change: '=ngChange',
                properties: '&?'
            },
            link: function ($scope, element, attrs) {
                $scope.properties = $scope.properties || _.noop;
                $scope.internal = {
                    model: $scope.model,
                    change: $scope.change
                };
                $scope.resolvedProperties = $scope.properties({ propertyType: $scope.param.propertyType });
                $scope.subButtonModel = {
                    menus: $scope.resolvedProperties,
                    'class': 'fa fa-tag'
                };
                if ($scope.param.propertiesHideFilter || $scope.param.propertiesHideAdvancedFilter) {
                    $scope.subButtonModel.menuOptions = {
                        hideFilter: $scope.param.propertiesHideFilter,
                        hideAdvancedFilter: $scope.param.propertiesHideAdvancedFilter
                    };
                }
                $scope.emailOptions = {
                    script_url: ($rootScope.runInIframe ? '/v1' : '') + '/assets/javascript/tinymce/tinymce.min.js',
                    plugins: [
                        'advlist autolink lists link image charmap print preview anchor',
                        'searchreplace visualblocks code',
                        'insertdatetime media table contextmenu paste textcolor'
                    ],
                    menubar: 'format',
                    toolbar: 'undo redo | styleselect | bold italic forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image tags',
                    statusbar: false,
                    height: $scope.param.editorHeight
                };
                $scope.addProperty = function (menuIds, withTag) {
                    $scope.internal.model = $scope.internal.model || '';
                    if (withTag) {
                        $scope.internal.model += '<p>';
                    }
                    var fullId = _(menuIds).chain().keys().first().value();
                    $scope.internal.model += '{' + fullId + '}';
                    if (withTag) {
                        $scope.internal.model += '</p>';
                    }
                };
                $scope.openTreeModal = function () {
                    var popup = $scope.param.popup || {};
                    modals.tree({ title: popup.title }, $scope.param.options, popup.size).then(function (selected) {
                        $scope.internal.model = selected;
                    });
                };
                function fileUploadChanged(e) {
                    if (e.target.files && e.target.files.length) {
                        $timeout(function () {
                            $scope.model = e.target.files[0];
                        });
                    }
                }
                $scope.copyTooltip = { content: { text: 'Copy to clipboard' } };
                $scope.copyToClipboard = function () {
                    try {
                        element.find('input')[0].select();
                        if (!document.execCommand('copy')) {
                            throw 'failed';
                        }
                        $scope.copyTooltip.content.text = 'Copied!';
                    } catch (err) {
                        $scope.copyTooltip.content.text = 'Failed to copy';
                    }
                    $timeout(function () {
                        $scope.copyTooltip.content.text = 'Copy to clipboard';
                    }, 1500);
                };
                $scope.paramDisabled = function (param) {
                    if (param.confirmPending) {
                        return true;
                    }
                    if (param.readOnly && param.type !== 'string') {
                        return true;
                    }
                    return false;
                };
                if ($scope.param.type === 'file') {
                    $timeout(function () {
                        element.find('input[type="file"]').on('change', fileUploadChanged);
                    });
                } else {
                    if ($scope.internal.change) {
                        $scope.$watch('internal.model', function (m) {
                            $parse($scope.internal.change);
                        }, true);
                    }
                    $scope.$watch('internal.model', function (m) {
                        $scope.model = $scope.internal.model;
                    }, true);
                    $scope.$watch('model', function (m) {
                        $scope.internal.model = $scope.model;
                    });
                }
                $scope.onChangedCheckbox = function (checked, event) {
                    if (checked) {
                        $rootScope.$broadcast(event + '-on');
                    } else {
                        $rootScope.$broadcast(event + '-off');
                    }
                };
                if ($scope.param.event) {
                    $scope.$on($scope.param.event + '-on', function () {
                        $scope.param.hideAsDefault = false;
                    });
                    $scope.$on($scope.param.event + '-off', function () {
                        $scope.param.hideAsDefault = true;
                    });
                }
                /*
             required settings params
             - example
             errTipContent: 'Not valid IP',
             parentElement: '.param-control',
             successTipContent: 'Valid IP',
             validation: true,
             validationType: 'ip'
             */
                if ($scope.param && $scope.param.settings && $scope.param.settings.validation) {
                    // add warning tooltip
                    var $parentFormControl = element.find($scope.param.settings.parentElement);
                    $parentFormControl.addClass('custom-tip');
                    $parentFormControl.append('<span class="custom-tip-text err-tip">' + $scope.param.settings.errTipContent + '</span>' + '<span class="custom-tip-text success-tip">' + $scope.param.settings.successTipContent + '</span>');
                    var changeBoxStyle = function (borderColor, isError, isSuccess) {
                        /*
                     normal color: #555555, border-color: #d5d7da,
                     error color: #ffffff, border-color: #cc4125
                     success color: #ffffff, border-color: #2db933
                     */
                        $parentFormControl.find('.form-control').each(function (key, $ele) {
                            angular.element($ele).css({ 'border-color': borderColor });
                        });
                        $parentFormControl.find('.err-tip').each(function (key, $ele) {
                            angular.element($ele).css({ 'visibility': isError ? 'visible' : 'hidden' });
                        });
                        $parentFormControl.find('.success-tip').each(function (key, $ele) {
                            angular.element($ele).css({ 'visibility': isSuccess ? 'visible' : 'hidden' });
                        });
                    };
                    if ($scope.param.settings.validationType === 'ip' || $scope.param.settings.validationType === 'domain') {
                        $scope.$watch('model', function (newVal, oldVal) {
                            if (newVal && newVal !== oldVal) {
                                if ($scope.param.settings.validationType === 'ip' && !regexUtility.utilities.validationIPandSubnet(newVal) || $scope.param.settings.validationType === 'domain' && !regexUtility.utilities.validationDomain(newVal)) {
                                    changeBoxStyle('#cc4125', true, false);
                                    $scope.param.settings.status = 'invalid';
                                } else {
                                    changeBoxStyle('#2db933', false, true);
                                    $scope.param.settings.status = 'valid';
                                }
                            }
                        });
                        angular.element(element).on('blur', '.form-control', function () {
                            changeBoxStyle('#d5d7da', false, false);
                        });
                        angular.element(element).on('focus', '.form-control', function (event) {
                            var currentData = angular.element(this).val();
                            if (currentData) {
                                if ($scope.param.settings.validationType === 'ip' && !regexUtility.utilities.validationIPandSubnet(currentData) || $scope.param.settings.validationType === 'domain' && !regexUtility.utilities.validationDomain(currentData)) {
                                    changeBoxStyle('#cc4125', true, false);
                                } else {
                                    changeBoxStyle('#2db933', false, true);
                                }
                            } else {
                                changeBoxStyle('#d5d7da', false, false);
                            }
                        });
                    }
                }
                $scope.toggleEyeIcons = 'fa-eye';
                $scope.togglePassword = function (event) {
                    var $passwordElement = $(event.currentTarget).closest('.form-control-password-wrapper').find('input.form-control-password');
                    var currentProp = $passwordElement.prop('type');
                    if (currentProp === 'password') {
                        $passwordElement.prop('type', 'text');
                        $scope.toggleEyeIcons = 'fa-eye-slash';
                    } else {
                        $passwordElement.prop('type', 'password');
                        $scope.toggleEyeIcons = 'fa-eye';
                    }
                };
            }
        };
    }]);
}());